import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {
  L10nConfig,
  L10nLoader,
  TranslationModule,
  StorageStrategy,
  ProviderType,
} from 'angular-l10n';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
// import { FileSelectDirective } from 'ng2-file-upload';
import { FileUploadModule } from 'ng2-file-upload';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

import { routing, pageComponents } from './app.routes';
import { AppComponent } from './app.component';
import { AlgHeaderComponent } from './components/alg-header/alg-header.component';
import { AlgSectionsContainerComponent } from './components/alg-sections-container/alg-sections-container.component';
import { AlgStatusBarComponent } from './components/alg-status-bar/alg-status-bar.component';
import { ApiService } from './services/api.service';
import { AlgGtmService } from './services/alg-gtm.service';
import { UtilsService } from './services/utils.service';
import { AlgFisicoService } from './services/alg-fisico.service';
import { AlgPrivacyService } from './services/alg-privacy.service';
import { AlgScontoService } from './services/alg-sconto.service';
import { AlgAttivazioniService } from './services/alg-attivazioni.service';

import { AlgProductCardComponent } from './components/molecules/alg-product-card/alg-product-card.component';
import { AlgStepComponent } from './components/alg-step/alg-step.component';
import { AlgUserInfoComponent } from './components/steps/alg-user-info/alg-user-info.component';
import { AlgSuppliesComponent } from './components/steps/alg-supplies/alg-supplies.component';
import { AlgPaymentComponent } from './components/steps/alg-payment/alg-payment.component';
import { AlgContractInfoComponent } from './components/steps/alg-contract-info/alg-contract-info.component';
import { CustomModalComponent } from './components/dialogs/custom-modal/custom-modal.component';
import { AlgCfModalComponent } from './components/dialogs/alg-cf-modal/alg-cf-modal.component';
import { StopOnboardingModalComponent } from './components/dialogs/stop-onboarding-modal/stop-onboarding-modal.component';
import { AlgConditionModalComponent } from './components/dialogs/alg-condition-modal/alg-condition-modal.component';
import { AlgPromoDetailsModalComponent } from './components/dialogs/alg-promo-details/alg-promo-details.component';
import { AlgConditionPrivacyModalComponent } from './components/dialogs/alg-condition-privacy-modal/alg-condition-privacy-modal.component';
import { AlgPrivacyModalComponent } from './components/dialogs/alg-privacy-modal/alg-privacy-modal.component';
import { AlgScontoComponent } from './pages/alg-sconto/alg-sconto.component';
import { AlgAttivazioniStopModalComponent } from './components/alg-attivazioni/dialogs/alg-attivazioni-stop-modal/alg-attivazioni-stop-modal.component';
import { AlgOtpModalComponent } from './components/dialogs/alg-otp-modal/alg-otp-modal.component';
import { AlgProgressHeaderComponent } from './components/molecules/alg-progress-header/alg-progress-header.component';
import { AlgProgressMobileComponent } from './components/molecules/alg-progress-mobile/alg-progress-mobile.component';
import { AlgFaqCardComponent } from './components/molecules/alg-faq-card/alg-faq-card.component';
import { AlgCallMeComponent } from './components/molecules/alg-call-me/alg-call-me.component';
import { AlgHeaderButtonComponent } from './components/atoms/alg-header-button/alg-header-button.component';
import { AlgContainerComponentsComponent } from './components/molecules/alg-container-components/alg-container-components.component';
import { AlgBillModalComponent } from './components/dialogs/alg-bill-modal/alg-bill-modal.component';
import { AlgEmailModalComponent } from './components/dialogs/alg-email-modal/alg-email-modal.component';
import { AlgSocioModalComponent } from './components/dialogs/alg-socio-modal/alg-socio-modal.component';
import { SharedModule } from './shared.module';
import { AlgConsensoPhysicalNextStepsComponent } from './components/molecules/alg-consenso-physical-next-steps/alg-consenso-physical-next-steps.component';
import { AlgConditionPrivacyModalSecondComponent } from './components/dialogs/alg-condition-privacy-modal-second/alg-condition-privacy-modal-second.component';
import { AlgConditionPrivacyModalThirdComponent } from './components/dialogs/alg-condition-privacy-modal-third/alg-condition-privacy-modal-third.component';
import { AlgAccessoriesElementComponent } from './components/steps/alg-accessories-element/alg-accessories-element.component';

import { AlgLinearModalComponent } from './components/dialogs/alg-linear-modal/alg-linear-modal.component';
import { AlgGreenEnergyComponent } from './components/molecules/alg-green-energy/alg-green-energy.component';
import { AlgProductsEnergyModalComponent } from './components/dialogs/alg-products-energy-modal/alg-products-energy-modal.component';
import { AlgGreenLinearModalComponent } from './components/dialogs/alg-green-linear-modal/alg-green-linear-modal.component';

import { AutomaticBillDiscountComponent } from './components/pdf-documents/automatic-bill-discount/automatic-bill-discount.component';

import { DatePipe } from '@angular/common';
import { AlgAutoricaricaComponentComponent } from './pages/alg-autoricarica/alg-autoricarica.component';
import { AlgAutoricaricaContractHeroComponent } from './components/molecules/alg-autoricarica-contract-hero/alg-autoricarica-contract-hero.component';
import { AlgAutoricaricaGeneralConditionComponent } from './components/molecules/alg-autoricarica-general-condition/alg-autoricarica-general-condition.component';
import { AlgAutoricaricaClientInfoComponent } from './components/molecules/alg-autoricarica-client-info/alg-autoricarica-client-info.component';
import { AlgAutoricaricaCodiciFornitureComponent } from './components/molecules/alg-autoricarica-codici-forniture/alg-autoricarica-codici-forniture.component';
import { AlgAutoricaricaTextRequestComponent } from './components/molecules/alg-autoricarica-text-request/alg-autoricarica-text-request.component';
const l10nConfig: L10nConfig = {
  locale: {
    languages: [{ code: 'it', dir: 'ltr' }],
    language: 'it',
    storage: StorageStrategy.Cookie,
  },
  translation: {
    providers: [
      {
        type: ProviderType.Static,
        prefix: './assets/locale-',
      },
    ],
    caching: true,
    missingValue: 'no key',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    ...pageComponents,
    AlgHeaderComponent,
    AlgSectionsContainerComponent,
    AlgStatusBarComponent,
    AlgProductCardComponent,
    AlgStepComponent,
    AlgUserInfoComponent,
    AlgSuppliesComponent,
    AlgPaymentComponent,
    CustomModalComponent,
    StopOnboardingModalComponent,
    AlgCfModalComponent,
    AlgConditionModalComponent,
    AlgPromoDetailsModalComponent,
    AlgConditionPrivacyModalComponent,
    AlgPrivacyModalComponent,
    AlgContractInfoComponent,
    AlgScontoComponent,
    AlgAttivazioniStopModalComponent,
    AlgOtpModalComponent,
    AlgProgressHeaderComponent,
    AlgProgressMobileComponent,
    AlgFaqCardComponent,
    AlgCallMeComponent,
    AlgHeaderButtonComponent,
    AlgContainerComponentsComponent,
    AlgBillModalComponent,
    AlgEmailModalComponent,
    AlgSocioModalComponent,
    AlgConsensoPhysicalNextStepsComponent,
    AlgConditionPrivacyModalSecondComponent,
    AlgConditionPrivacyModalThirdComponent,
    AlgAccessoriesElementComponent,
    AlgLinearModalComponent,
    AlgGreenEnergyComponent,
    AlgProductsEnergyModalComponent,
    AlgGreenLinearModalComponent,
    AlgAutoricaricaComponentComponent,
    AlgAutoricaricaContractHeroComponent,
    AlgAutoricaricaGeneralConditionComponent,
    AlgAutoricaricaClientInfoComponent,
    AlgAutoricaricaCodiciFornitureComponent,
    AlgAutoricaricaTextRequestComponent,
    AutomaticBillDiscountComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    routing,
    TranslationModule.forRoot(l10nConfig),
    ModalDialogModule.forRoot(),
    BrowserAnimationsModule,
    NgSelectModule,
    FileUploadModule,
    GooglePlaceModule,
  ],
  // tslint:disable-next-line:max-line-length
  entryComponents: [
    AlgOtpModalComponent,
    CustomModalComponent,
    StopOnboardingModalComponent,
    AlgCfModalComponent,
    AlgPromoDetailsModalComponent,
    AlgConditionModalComponent,
    AlgConditionPrivacyModalComponent,
    AlgPrivacyModalComponent,
    AlgAttivazioniStopModalComponent,
    AlgProductCardComponent,
    AlgContainerComponentsComponent,
    AlgBillModalComponent,
    AlgEmailModalComponent,
    AlgSocioModalComponent,
    AlgConditionPrivacyModalSecondComponent,
    AlgConditionPrivacyModalThirdComponent,
    AlgLinearModalComponent,
    AlgProductsEnergyModalComponent,
    AlgGreenLinearModalComponent,
  ],
  providers: [
    ApiService,
    AlgGtmService,
    UtilsService,
    AlgFisicoService,
    AlgPrivacyService,
    AlgScontoService,
    AlgAttivazioniService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(public l10nLoader: L10nLoader) {
    this.l10nLoader.load();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts